/* eslint-disable */
import { scrollToPos, ifMobile } from "./helpers";
import { currentBreakpoint } from "../breakpoint";

document.addEventListener("alpine:init", () => {

    Alpine.data("buttonSticky", () => ({
        config: {
            iterations: 1,
            duration: 300
        },
        duration: 290,
        buttonShrinkWidth: "80px",
        buttonWidth: 0,
        loadDone: false,
        scrollY: 0,
        init() {
            const buttonSticky = this.$refs.buttonStickyElem;
            this.buttonWidth = buttonSticky.clientWidth;

            if (buttonSticky) {
                const { delay, scroll, scrollMobile, state } = buttonSticky?.dataset;
                    
                if (state === "collapsed") this.autoCollapsed(buttonSticky);                 

                window.onload = () => {
                    this.loadDone = true;
                    
                    if (delay) this.timeDelay();

                    const scrollDevice = ifMobile() ? scrollMobile : scroll;
                    this.initScroll(scrollDevice);
                };
            }
        },
        initScroll(scroll) {
            if (scroll === "collapse") this.scrollHide();
            else if (scroll === "expand") this.scrollShow();
        },
        windowScroll() {
            let scrollTop = document.documentElement.scrollTop;
            let scrolledUp = scrollTop < this.scrollY
            if (scrolledUp) {
                const buttonSticky = this.$refs.buttonStickyElem;
                const device = buttonSticky?.dataset.expandOnScrollUp;
                if (device === 'none' || device === undefined) return
                if (["xs", "sm", "md"].includes(currentBreakpoint()) && device !== 'mobile') return
                if (["lg", "xl"].includes(currentBreakpoint()) && device !== 'desktop') return
                this.mouseEnter(this)
            }
            this.scrollY = scrollTop <= 0 ? 0 : scrollTop
        },
        elems() {
            const buttonSticky = this.$refs.buttonStickyElem;
            
            if (!buttonSticky) return;

            const description = buttonSticky.querySelector(".buttonSticky__text");
    
            return {
                buttonSticky,
                description
            };
        },
        expandAnimation(button = {}) {
            if (!button?.buttonSticky) return;
  
            const { buttonSticky, description } = button;
            const hovered = buttonSticky.classList.contains("buttonSticky--hovered");
            const animated = buttonSticky.classList.contains("buttonSticky--animated");

            if (!animated || hovered) return;

            description.classList.remove("hidden");    
            buttonSticky.classList.replace("buttonSticky--animated", "buttonSticky--animate");
    
            buttonSticky.animate([
                { width: this.buttonShrinkWidth },
                { width: `${this.buttonWidth}px` }
            ], this.config);
    
            description.animate([
                { opacity: 0 },
                { opacity: 1 }
            ], this.config);

            setTimeout(() => buttonSticky.classList.remove("w-20"), this.duration);
        },
        hideAnimation(button = {}) {
            if (!button?.buttonSticky) return;
    
            const { buttonSticky, description } = button;
    
            if (buttonSticky.classList.contains("buttonSticky--animated")) return;
    
            buttonSticky.classList.replace("buttonSticky--animate", "buttonSticky--animated");
    
            buttonSticky.animate([
                { width: `${this.buttonWidth}px` },
                { width: this.buttonShrinkWidth }
            ], this.config);
    
            description.animate([
                { opacity: 1 },
                { opacity: 0 }
            ], this.config);
    
            setTimeout(() => this.multiAddClass([buttonSticky, description], ["w-20", "hidden"]), this.duration);
        },
        timeDelay() {
            const timeDelay = this.elems().buttonSticky?.dataset.delay;
            setTimeout(() => {
                this.hideAnimation(this.elems());
            }, timeDelay)
        },
        scrollHide() {
            window.addEventListener("scroll", () => {
                if (window.scrollY > 10) {
                    this.hideAnimation(this.elems());
                }
            });
        },
        scrollShow() {
            let timeOut;
            window.addEventListener("scroll", () => {
                if (window.scrollY > 10) {
                    clearTimeout(timeOut);
                    this.expandAnimation(this.elems());

                    timeOut = setTimeout(() => this.hideAnimation(this.elems()), 1e3);
                }
            });
        },
        autoCollapsed(elem) {
            const buttonSticky = elem;
            const description = buttonSticky.querySelector(".buttonSticky__text");
            this.multiAddClass([buttonSticky, description], ["w-20", "hidden"]);
        },
        multiAddClass(elem= [], classes= []) {
            elem.forEach((el, key) => el.classList.add(classes[key]))
        },
        multiRemoveClass(elem= [], classes= []) {
            elem.forEach((el, key) => el.classList.remove(classes[key]))
        },
        scrollToFromPlatform(id) {
            scrollToPos(id);
            setTimeout(() => {
                const buttonSticky = this.$refs.buttonStickyElem;
            
                const mouseLeaveEvent = new MouseEvent('mouseleave', {
                    bubbles: true,
                    cancelable: true
                });
            
                buttonSticky.dispatchEvent(mouseLeaveEvent);
            }, 3000);            
        },
        mouseEnter() {            
            const buttonSticky = this.$el;
            const animated = buttonSticky.classList.contains("buttonSticky--animated");
            const hovered = buttonSticky.classList.contains("buttonSticky--hovered");
            const description = buttonSticky.querySelector(".buttonSticky__text");
            
            if (!hovered && this.loadDone) {    
                description.classList.remove("hidden");
                buttonSticky.classList.add("buttonSticky--hovered");

                if (animated) {
                    buttonSticky.animate([
                        { width: this.buttonShrinkWidth },
                        { width: `${this.buttonWidth}px` }
                    ], this.config);
    
                    description.animate([
                        { opacity: 0 },
                        { opacity: 1 }
                    ], this.config);
    
                    setTimeout(() => buttonSticky.classList.remove("w-20"), this.duration);
                } else {
                    buttonSticky.classList.replace("buttonSticky--animate", "buttonSticky--animated");
                }                
                
            }
        },
        mouseLeave() {
            const buttonSticky = this.$el;
            const animated = buttonSticky.classList.contains("buttonSticky--animated");
            const hovered = buttonSticky.classList.contains("buttonSticky--hovered");
            const description = buttonSticky.querySelector(".buttonSticky__text");

            if (animated && hovered && this.loadDone) {
                buttonSticky.classList.remove("buttonSticky--hovered");

                buttonSticky.animate([
                    { width: `${this.buttonWidth}px` },
                    { width: this.buttonShrinkWidth }
                ], this.config);

                description.animate([
                    { opacity: 1 },
                    { opacity: 0 }
                ], this.config);
        
                setTimeout(() => this.multiAddClass([buttonSticky, description], ["w-20", "hidden"]), this.duration);
            }
        },
        pageRedirect() {
            const { href, target } = this.$el;
            
            if (window.innerWidth < 1025) setTimeout(() => window.open(href, target), 1e3);
            else window.open(href, target);
        }
    }));

});
